module.exports = __webpack_public_path__ + "static/media/15.b070d5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/15.png
// module id = 1055
// module chunks = 0